export const exportType = {
    CSV: 'csv',
    XLSX: 'xlsx',
    TXT: 'txt',
    JSON: 'json',
}
